<template>
  <div>
    <b-form inline @submit="onSubmit">
      <label class="sr-only" for="inlineFormInputTipo">Tipo</label>
      <b-form-select class="mb-2 mr-sm-2 mb-sm-0" v-model="form.movtype" :options="options" id="inlineFormInputTipo">
      <option slot="first" :value=0>Tipo Mov.</option>
      </b-form-select>
      <label class="sr-only" for="inlineFormInputAmount">Importe </label>
      <b-input class="w-5" id="inlineFormInputAmount" v-model="form.amount" placeholder="Importe" />
      <label class="sr-only" for="inlineFormInputAmountDesc">Descripción </label>
      <b-input class="w-50" id="inlineFormInputAmountDesc" v-model="form.desc" placeholder="Descripción" />
      <b-button type="submit" variant="primary">Añadir</b-button>
    </b-form>
    <b-card-body title="Movimientos de caja">
                <b-table striped hover :items="paymMethods" :fields="fields"></b-table>
                <b-button @click="PostCashMov" variant="primary">Registrar</b-button>
    </b-card-body>

    <!-- Modal Component para solo permitir imprimir tras Registro Correcto. -->
        <b-modal @hide="ModalClose" hide-footer ref="ModalRef" id="modal1" title="Registro correcto!">
            <b-list-group>           
            <b-btn class="mt-3" variant="outline-danger" block @click="ModalClose">Finalizar</b-btn>
            </b-list-group>
        </b-modal>
  </div>
</template>

<script>

export default {
    name: 'CashMovInput',    
    data() {
        return {           
        //Open,Close,Cash In,Cash Out,Sale,Expense,Payment
        form: {
            posid: localStorage.getItem('posId'),
            movtype: 0,
            paymenttype: '',
            amount: '',
            desc: '',
            doctype : 1,
            docno : "",
            paymdate : "",
            posuserid : "",
            anticipo : false,
            new : true  
        },
        fields: [{key: 'paymdate',label: 'Fecha', formatter: (value) => {
                            var event = new Date(value);
                            var options = { year: 'numeric', month: 'numeric', day: 'numeric' };;
                            return event.toLocaleDateString("es-ES", options)
                          }},
                     {key: 'paymenttype',label: 'Forma de Pago'},
                     {key: 'amount',label: 'Importe'},
                     {key: 'desc',label: 'Descripción'},
                     {key: 'movtype',label: 'Tipo',formatter: (value) => {
                            switch(value){
                                case 2: return 'Entrada efectivo'
                                break;
                                case 3: return 'Salida efectivo'
                                break;
                                case 5: return 'Gasto'
                                break;
                            }
                          }}
        ],
        options: [
                { value: 2, text: 'Entrada efectivo' },
                { value: 3, text: 'Salida efectivo' },
                { value: 5, text: 'Gasto' }                             
            ],
        CashPaymentMethod : []
        
        }
    },
    methods: {
        onSubmit (evt) {
            evt.preventDefault();
            let option = {...this.form};

            let pdate = new Date()
            let optiondate = new Date(pdate.getTime() - (pdate.getTimezoneOffset() * 60000 ))
                        .toISOString()
                        .split("T")[0];
            
            if (parseFloat(this.form.amount) > 0 &&  this.form.movtype != 0){
                option.paymdate = optiondate
                option.posuserid = this.$store.state.UserCardId.return_value  
                option.paymenttype = this.CashPaymentMethod[0].paymenttype                
                this.$store.commit('addCashMov', option)
                //this.$nextTick(() => {this.$refs.AmountInput.focus()})                
            }
        },
        PostCashMov(){            
            var req = {
                docno : this.$store.state.curOrder,
                //paymmovs : this.$store.state.paymMethods,
                paymmovs : this.$store.getters.NewPaymMovs,
                OrderTotalPaym : this.$store.getters.OrderTotalPaym
                }

            this.axios.post(this.ApiBaseUrl + 'PosFunctions/CashMovsPost',JSON.stringify(req),{headers: {"Content-Type": "application/json"}})
            .then((response) => {        
               this.$refs.ModalRef.show()                 
            })
        },
        ModalClose(){
           this.$store.dispatch("resetPOS")
           this.$router.push('setup') 
        }
    },
    created: function () {
        this.axios.post(this.ApiBaseUrl + 'possetup/GetCashPaymentmethods',JSON.stringify(localStorage.getItem('posId')),{headers: {"Content-Type": "application/json"}})
            .then((response) => {        
                this.CashPaymentMethod = response.data; 
            })                 
    },
    computed:{
        paymMethods(){
            return this.$store.state.paymMethods;
        }
    }   
}
</script>